import styled from '@emotion/styled'

const StyledInput = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: var(--White90);
  outline: none;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--Red-Dark);
    cursor: pointer;
  }
  &::-moz-range-thumb {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--Red-Dark);
    cursor: pointer;
  }
`

export type SliderProps = {
  max?: number
  min?: number
  onChange?: (value: number) => void
  step?: number
  value?: number
}

export function Slider({ onChange, ...props }: SliderProps) {
  return (
    <StyledInput
      {...props}
      type="range"
      onChange={e => onChange && onChange(Number(e.target.value))}
    />
  )
}
